$(document).ready(function () {
    const header = $('.header'),
        scrollClass = 'header_scrolled';

    const checkScroll = () => {
        if ($(window).scrollTop() > header.height()) {
            if (header.hasClass(scrollClass))
                return;

            header.addClass(scrollClass);
        }
        else {
            header.removeClass(scrollClass)
        }
    };

    checkScroll();
    $(window).on('scroll', checkScroll);
});